import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';
import { DefaultService, InspectionReportByNode} from "@psnb/psnb-api";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelInspectionReportByNodeService {
  searchHieArray: any;

  constructor(private powerSupplyService: DefaultService) { }

  public getPowerSuppliesByNodeInspectionReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getPowerSuppliesByNodeInspectionReports(this.searchHieArray);
  }

  public exportInspectionReportByNodeAsExcelFile(json: InspectionReportByNode[], excelFileName: string, fileType: string) {
    let min = 0;
    let max = 40000;
    let numberOfSheets = 0;
    if (json.length >= 40000) {
      if (json.length % 40000 === 0) numberOfSheets = json.length / 40000;
      else numberOfSheets = json.length / 40000 + 1;
    } else {
      numberOfSheets = 1;
      max = json.length;
    }
    const workbook = new Excel.Workbook;
    for (let i = 1; i <= numberOfSheets; i++) {
      workbook.addWorksheet('InspectionReportByNode' + i);
      const sheet = workbook.getWorksheet(i);
      sheet.columns = this.getHeaders(fileType);
      sheet.addRows(json.slice(min, max));
      if (fileType === 'INSPECTIONBYNODE') {
        sheet.eachRow(function (row, rowNumber) {
          row.eachCell({ includeEmpty: true }, function (cell) {
            if (rowNumber === 1) {
              sheet.getCell(cell.address.toString()).fill = {
                type: 'gradient', gradient: 'angle', degree: 0, stops: [
                  { position: 0, color: { argb: 'd9f1fa' } },
                  { position: 0.5, color: { argb: 'd9f1fa' } },
                  { position: 1, color: { argb: 'd9f1fa' } }
                ]
              };
              sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
              sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
              sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
            }
          });
        });
      }
      if (max + 40000 <= json.length) {
        min = max;
        max = max + 40000;
      } else {
        min = max;
        max = max + (json.length - max);
      }
    }
    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
    })
    return false;
  }

  getHeaders(fileType: string) {
    if (fileType === 'INSPECTIONBYNODE') {
      let wchPowerSupplyId = 14;
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchName = 9;
      let wchPowerSupplyName = 20;
      let wchIp = 12;
      let wchMacAddress = 13;
      let wchMacAddressPrevious = 20;
      let wchPsAlertProfile = 30;
      let wchControlledCardType = 18;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 10;
      let wchState = 6;
      let wchZip = 8;
      let wchGpsLatitude = 12;
      let wchGpsLongitude = 13;
      let wchPoleNumber = 11;
      let wchPowerCompanyVendor = 21;
      let wchCompanyAccountNumber = 25;
      let wchPowersNode = 11;
      let wchElectricMeterNumber = 20;
      let wchMapNumber = 10;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchNumberOfBatteries = 20;
      let wchMiscellaneous = 25;
      let wchcalculatedRuntime = 25;
      let wchPowerSupplyType = 16;
      let wchFeedsMultipleNodes = 18;
      let wchPowerSupplyNumber = 17;
      let wchPowerSupplyType9360 = 20;
      let wchTransponderVendor = 20;
      let wchTransponderModel = 17;
      let wchPowerSupplyModel = 17;
      let wchOutputVoltage = 14;
      let wchACInputVoltage = 14;
      let wchInputCurrent = 13;
      let wchCurrentAmpOutput = 17;
      let wchBatteriesReplaced = 17;
      let wchBatteryBalancerString = 23;
      let wchAerialUnderground = 20;
      let wchEgisName = 13;
      let wchComments = 30;
      let wchFollowUpNeeded = 23;
      let wchFollowUpReason =33;
      let wchVisitStatus =25;
      let wchnwtTeam = 15;
      let wchnitroCompletionDate = 15;
      let wchPowerAccountType = 20;
  
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'RegionName', key: 'regionName', width: wchRegionName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'HeadendName', key: 'headendName', width: wchHeadendName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'NodeName', key: 'nodeName', width: wchName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'IP', key: 'ip', width: wchIp, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'MACAddress', key: 'macAddress', width: wchMacAddress, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'MACAddressPrevious', key: 'macAddressPrevious', width: wchMacAddressPrevious, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PsAlertProfile', key: 'psAlertProfile', width: wchPsAlertProfile, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        // { header: 'ControlledCardType', key: 'controllerCardType', width: wchControlledCardType, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: wchPowerSupplyAddress, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'CrossStreet', key: 'crossStreet', width: wchCrossStreet, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'City', key: 'city', width: wchCity, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'State', key: 'state', width: wchState, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Zip', key: 'zip', width: wchZip, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'GpsLatitude', key: 'gpsLatitude', width: wchGpsLatitude, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'GpsLongitude', key: 'gpsLongitude', width: wchGpsLongitude, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PoleNumber', key: 'poleNumber', width: wchPoleNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerCompanyVendor', key: 'powerCompanyVendor', width: wchPowerCompanyVendor, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Team', key: 'companyAccountNumber', width: wchCompanyAccountNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowersNode', key: 'powersNode', width: wchPowersNode, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerAccountType', key: 'powerAccountType', width: wchPowerAccountType, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'ElectricMeterNumber', key: 'electricMeterNumber', width: wchElectricMeterNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'MapNumber', key: 'mapNumber', width: wchMapNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node2', key: 'node2', width: wchNode2, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node3', key: 'node3', width: wchNode3, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node4', key: 'node4', width: wchNode4, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node5', key: 'node5', width: wchNode5, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node6', key: 'node6', width: wchNode6, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node7', key: 'node7', width: wchNode7, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node8', key: 'node8', width: wchNode8, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node9', key: 'node9', width: wchNode9, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node10', key: 'node10', width: wchNode10, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node11', key: 'node11', width: wchNode11, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node12', key: 'node12', width: wchNode12, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node13', key: 'node13', width: wchNode13, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node14', key: 'node14', width: wchNode14, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Node15', key: 'node15', width: wchNode15, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'NumberOfBatteries', key: 'numberOfBatteries', width: wchNumberOfBatteries, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Miscellaneous', key: 'miscellaneous', width: wchMiscellaneous, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Calculated Runtime(in Minutes)', key: 'calculatedRuntime', width: wchcalculatedRuntime, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyType', key: 'powerSupplyType', width: wchPowerSupplyType, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'FeedsMultipleNodes', key: 'feedsMultipleNodes', width: wchFeedsMultipleNodes, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyNumber', key: 'powerSupplyNumber', width: wchPowerSupplyNumber, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyType9360', key: 'powerSupplyType9360', width: wchPowerSupplyType9360, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'TransponderVendor', key: 'transponderVendor', width: wchTransponderVendor, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'TransponderModel', key: 'transponderModel', width: wchTransponderModel, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'PowerSupplyModel', key: 'powerSupplyModel', width: wchPowerSupplyModel, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'OutputVoltage', key: 'outputVoltage', width: wchOutputVoltage, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'ACInputVoltage', key: 'acInputVoltage', width: wchACInputVoltage, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'InputCurrent', key: 'inputCurrent', width: wchInputCurrent, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'CurrentAmpOutput', key: 'currentAmpOutput', width: wchCurrentAmpOutput, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'BatteriesReplaced', key: 'batteriesReplaced', width: wchBatteriesReplaced, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'BatteryBalancerString', key: 'batteryBalancerString', width: wchBatteryBalancerString, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'AerialUnderground', key: 'aerialUnderground', width: wchAerialUnderground, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'EgisName', key: 'egisName', width: wchEgisName, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'Comments', key: 'comments', width: wchComments, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'FollowUpNeeded', key: 'followUpNeeded', width: wchFollowUpNeeded, style: { font: { name: 'Calibri', family: 2, size: 8 } } },

        { header: 'NWTTeam', key: 'nwtTeam', width: wchnwtTeam, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'NitroCompletionDate', key: 'nitroCompletionDate', width: wchnitroCompletionDate, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'FollowUpReason', key: 'followUpReason', width: wchFollowUpReason, style: { font: { name: 'Calibri', family: 2, size: 8 } } },
        { header: 'VisitStatus', key: 'visitStatus', width: wchVisitStatus, style: { font: { name: 'Calibri', family: 2, size: 8 } } }
      ]
    }
  }
}
